// Typed endpoint functions (plan §4). One namespace per API module; later tasks add theirs here.
import { createHttp, type HttpOptions } from './http.ts';
import { meSchema, nonceSchema, type Me } from './schemas.ts';

export interface AuthApi {
  /** GET /auth/nonce: single-use value passed to MSAL so Entra puts it in the ID token. */
  getNonce(signal?: AbortSignal): Promise<string>;
  /** POST /auth/session: trades the ID token for the session cookie; returns the signed-in person. */
  createSession(idToken: string): Promise<Me>;
  /** DELETE /auth/session: revokes the session on the server (204). */
  deleteSession(): Promise<void>;
}

export interface MeApi {
  /** GET /me: the signed-in person, permissions and the applied content-pack version. */
  get(signal?: AbortSignal): Promise<Me>;
}

export interface ApiClient {
  readonly auth: AuthApi;
  readonly me: MeApi;
}

export function createApiClient(options: HttpOptions = {}): ApiClient {
  const http = createHttp(options);
  return {
    auth: {
      getNonce: async (signal) =>
        (await http.json({ method: 'GET', path: '/auth/nonce', signal }, nonceSchema)).nonce,
      createSession: (idToken) =>
        http.json({ method: 'POST', path: '/auth/session', body: { idToken } }, meSchema),
      deleteSession: () => http.noContent({ method: 'DELETE', path: '/auth/session' }),
    },
    me: {
      get: (signal) => http.json({ method: 'GET', path: '/me', signal }, meSchema),
    },
  };
}
